import {
  deleteEmailDialogTranslation,
  DeleteEmailDialogTranslation,
} from '@/assets/locales/views/emails/threadEmails/threadEmails.translation.pl.ts';
import { EmailSearchRequestFormModel } from '@/views/emails/components/threadsList/components/header/components/search/model/EmailSearchRequestForm.model.ts';

export type ThreadsListTranslation = {
  allThreadsDisplayed: string;
  body: {
    noSubject: string;
  };
  deleteEmailDialog: DeleteEmailDialogTranslation;
  deleteThreadDialog: {
    button: {
      cancel: string;
      ok: string;
    };
    content: string;
    title: string;
  };
  header: {
    button: {
      newEmail: string;
      search: string;
    };
    search: {
      emailValidationFailed: string;
      form: Record<keyof EmailSearchRequestFormModel, string> & {
        button: {
          clear: string;
          search: string;
        };
      };
    };
  };
  noThreadsInFolder: string;
};

export const threadsListTranslation: ThreadsListTranslation = {
  allThreadsDisplayed: 'Nie ma więcej wiadomości do wyświetlenia',
  body: {
    noSubject: 'Brak tematu',
  },
  deleteEmailDialog: deleteEmailDialogTranslation,
  deleteThreadDialog: {
    button: {
      cancel: 'Anuluj',
      ok: 'Usuń',
    },
    content: 'Czy na pewno chcesz usunąć ten wątek?',
    title: 'Usuń wątek',
  },
  header: {
    button: {
      newEmail: 'Nowa wiadomość',
      search: 'Szukaj',
    },
    search: {
      emailValidationFailed: 'Niepoprawny adres email',
      form: {
        button: {
          clear: 'Wyczyść',
          search: 'Szukaj',
        },
        dwEmail: 'Kopia',
        from: 'Od',
        fromEmail: 'Nadawca',
        search: 'Szukaj',
        subject: 'Temat',
        to: 'Do',
        toEmail: 'Odbiorca',
        unreadOnly: 'Tylko nieprzeczytane',
      },
    },
  },
  noThreadsInFolder: 'Brak wątków w tej skrzynce pocztowej',
};
